(function() {

	angular
		.module('ngmvac')
		.filter('nameHotelFilter', NameHotelFilter);

	function NameHotelFilter() {
		


		

		return function(arr, name) {

         var hotelArray = [];
         var arrAux     =[];

			angular.forEach(arr, function(hotel) {
             	hotelArray.push(hotel);
			});


     var nombre="";
    for(var i=0; i<hotelArray.length; i++) 
    {
        	
              nombre=hotelArray[i].name;
            if(nombre.toLowerCase().indexOf(name.toLowerCase())!=-1) 
            {
             	arrAux.push(hotelArray[i]);
            }
     }
   return arrAux;
}
			
		}
	

})();